import { extractEntidadeFromPath, isEntidadeNaoResolvida } from 'common/utils';
import { axios } from 'libs';

const resource = '/usuarios';

export const getUserData = () => {
  return axios.get(`${resource}/me`);
};

export const getUserPermissions = () => {
  const idEntidade = extractEntidadeFromPath()?.idEntidade;

  if (idEntidade && !isEntidadeNaoResolvida(idEntidade)) {
    return axios.get(`${resource}/permissoes`).catch(e => {
      //Ao cancelar uma requisição ele o erro volta com a message Network Error e response undefined
      if (e.message === 'Network Error' && !e.response) return;
    });
  }

  return Promise.resolve({ data: { clientRoles: [] } });
};
